import { ChangeDetectionStrategy, Component, computed, input } from '@angular/core';

export type BzDividerOrientation = 'horizontal' | 'vertical';

/**
 * A thin rule separating sections of content. No legacy equivalent — every
 * app drew its own `<hr>` with its own colour.
 *
 * `vertical` needs a sizing context: it stretches to 100% of the parent's
 * block size, so the parent must give it one (a flex row with `align-items:
 * stretch`, or an explicit height).
 */
@Component({
  selector: 'bz-divider',
  template: '',
  styleUrl: './bz-divider.scss',
  host: {
    role: 'separator',
    '[class]': 'hostClass()',
    '[attr.aria-orientation]': 'orientation()',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BzDivider {
  readonly orientation = input<BzDividerOrientation>('horizontal');

  protected readonly hostClass = computed(() => `bz-divider bz-divider--${this.orientation()}`);
}
